import type { Node } from "@xyflow/react"
import type { ProjectNodeData } from "@/types/project"

export const DEFAULT_NODE_WIDTH = 280
export const DEFAULT_NODE_HEIGHT = 120
export const PALETTE_VERTICAL_OFFSET = 14

export function getNodeSize(node: Node<ProjectNodeData>) {
	return {
		width: node.measured?.width ?? node.width ?? DEFAULT_NODE_WIDTH,
		height: node.measured?.height ?? node.height ?? DEFAULT_NODE_HEIGHT,
	}
}

export function getNodesBounds(nodes: Node<ProjectNodeData>[]) {
	if (nodes.length === 0) {
		return null
	}

	const first = nodes[0]
	if (!first) {
		return null
	}
	const firstSize = getNodeSize(first)

	let minX = first.position.x
	let minY = first.position.y
	let maxX = first.position.x + firstSize.width
	let maxY = first.position.y + firstSize.height

	for (const node of nodes.slice(1)) {
		const size = getNodeSize(node)
		const nodeMinX = node.position.x
		const nodeMinY = node.position.y
		const nodeMaxX = node.position.x + size.width
		const nodeMaxY = node.position.y + size.height

		if (nodeMinX < minX) minX = nodeMinX
		if (nodeMinY < minY) minY = nodeMinY
		if (nodeMaxX > maxX) maxX = nodeMaxX
		if (nodeMaxY > maxY) maxY = nodeMaxY
	}

	return {
		x: minX,
		y: minY,
		width: maxX - minX,
		height: maxY - minY,
	}
}
